import { Component, ReactNode } from 'react';

export class ErrorBoundary extends Component<
  {
    children?: ReactNode;
    fallback?: (error: Error, retry: () => void) => ReactNode;
  },
  { error: Error | null }
> {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    console.error('ErrorBoundary caught', error);
    return { error };
  }

  render() {
    if (this.state.error) {
      return this.props.fallback?.(this.state.error, () =>
        this.setState(() => ({ error: null }))
      );
    }

    return this.props.children;
  }
}
